// Objetivo: formatar o tempo relativo de uma data
import moment from "moment"

function formatarTempoRelativo(ultimaMensagemData) {
  const now = moment()
  const duration = moment.duration(now.diff(ultimaMensagemData))
  if (duration.asSeconds() < 60) {
    return "~1 min"
  } else if (duration.asHours() < 1) {
    return `${Math.floor(duration.asMinutes())} min`
  } else if (duration.asDays() < 1) {
     const horas = Math.floor(duration.asHours())
    return horas === 1 ? "1 hr" : `${horas} hrs`
  } else if (duration.asDays() < 2) {
    return `${Math.floor(duration.asDays())} dia`
  } else {
    return `${Math.floor(duration.asDays())} dias`
  }
}

export default formatarTempoRelativo
